import "./Title.css"

export default function Title({children}) {
    return (
        <h2 className={'detail-title'}>{children}</h2>
    )
}